import { Popover, Text } from "@mantine/core";
import { React } from "react";
import { IconInfoCircle } from "@tabler/icons-react";
import { useDisclosure, useMediaQuery } from "@mantine/hooks";

export const Tooltip = (props) => {
  const [opened, { close, open }] = useDisclosure(false);
  const isMobile = useMediaQuery("(max-width: 480px)", true, {
    getInitialValueInEffect: false,
  });

  return (
    <Popover
      position="top"
      width={210}
      style={{ marginBottom: props.marginBottom, marginLeft: props.marginLeft }}
      opened={opened}
    >
      <Popover.Target>
        <IconInfoCircle size={isMobile ? 30 : 20} onMouseEnter={open} onMouseLeave={close} />
      </Popover.Target>
      <Popover.Dropdown>
        <Text size="xs">{props.label}</Text>
      </Popover.Dropdown>
    </Popover>
  );
};
